export default {
  name: "",
  email: "",
  designation: "",
  country: "",
  phoneNumber: "",
  cobjective: "",
};
